import { RotateCcw, TriangleAlert } from 'lucide-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

import { Button, Page, StatePanel } from '@/components';

type State = { error: Error | null };

/** Catches render errors. Logs without query strings or tokens. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(
      'Render error on',
      window.location.pathname,
      error.name,
      info.componentStack?.split('\n')[1]?.trim(),
    );
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <Page width="medium">
        <StatePanel
          icon={TriangleAlert}
          title="Something went wrong on this page."
          headingLevel="h1"
          role="alert"
          actions={
            <>
              <Button iconLeft={RotateCcw} onClick={() => window.location.reload()}>
                Reload the page
              </Button>
              <Button variant="outline" href="/">
                See all trips
              </Button>
            </>
          }
        >
          Your booking details are safe on our side. Reloading usually fixes this.
        </StatePanel>
      </Page>
    );
  }
}
